var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgText = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Capa_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 278 278",
  style: {
    enableBackground: "new 0 0 278 278"
  },
  xmlSpace: "preserve",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M254.833,0h-98.5h-33h-99.5C15.549,0,8.5,6.716,8.5,15v33c0,8.284,6.716,15,15,15s15-6.716,15-15V30h69v218H89.833 c-8.284,0-15,6.716-15,15s6.716,15,15,15h99c8.284,0,15-6.716,15-15s-6.716-15-15-15H170.5V30h69v18c0,8.284,6.716,15,15,15 s15-6.716,15-15V15C269.5,6.716,263.117,0,254.833,0z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgText);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/text.dfce38059b687c415ee73120c9b0fc6b.svg";